import { formatEther, parseEther } from 'ethers/lib/utils';

const calculatePercentageDifference = (
    newValue: number | string,
    originalValue: number | string
) => {
    const current = parseEther(newValue.toString());
    const original = parseEther(originalValue.toString());

    if (current.isZero() || original.isZero()) return '0';

    return formatEther(current.sub(original).mul(parseEther('100')).div(original));
};

export default calculatePercentageDifference;
